import React from 'react';

import { createNode } from './createNode';

import { BuilderComponent, DesignSettings, Node } from '../interfaces';

export function parseNodeFromJSX(
    jsx: React.ReactElement,
    designSettings: DesignSettings,
    normalize?: (node: Node, jsx: React.ReactElement) => void,
) {
    const actualType = jsx.type as BuilderComponent<never>;

    return createNode(
        {
            data: {
                type: actualType,
                props: { ...jsx.props, designSettings },
            },
        },
        (node) => {
            if (normalize) {
                normalize(node, jsx);
            }
        },
    );
}
